import { itiHttpService } from './../../iti-core-vue/services/iti-http-service';
import Header from '@/components/public-header/public-header.component.vue';
import Footer from '@/components/public-footer/public-footer.component.vue';
import { itiPermissionService, itiTokenService } from '@/iti-core-vue';
import { Permission } from '@/shared';
import { MenuOptions } from '@/shared/menu-options';
import { Component, Vue } from "vue-property-decorator";
import AuthService from '@/shared/services/auth.service';
const auth = new AuthService();

@Component({
  components: {
    Header,
    Footer,
  }
})
export default class PublicLayout extends Vue {

  public appTitle = process.env.VUE_APP_TITLE;

  public fullMenuOptions = MenuOptions;

  public currentUser: string | undefined = '';
  public accessTokenExpired: boolean | undefined = false;
  public isLoggedIn: boolean = false;



  created() {
  }
  public mounted() {
    auth.getUser().then((user) => {
      //console.log(user);
      if (user) {
        itiTokenService.setToken(user.access_token);
        itiHttpService.updateHeader();
        this.currentUser = user.profile?.name;
        this.accessTokenExpired = user.expired;
        this.isLoggedIn = (user !== null && !user.expired);
      }
    });


  }

  public get imgPie() {
    return process.env.VUE_APP_PUBLIC_PATH + 'assets/symbinet-pie.png';
  }
}
